import moment from "moment/moment";
import Text from "../UI/Text";
import Button from "../UI/Button";
import { type Compteur } from "../../hooks/use-compteur";
import { CompteurType } from "../../models/compteur";
import styles from "./CompteurHistory.module.css";
import ModalDialog, { ModalDialogFooter } from "../UI/ModalDialog";
import { IconEdit } from "@tabler/icons-react";

interface CompteurHistoryProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  compteurType: CompteurType | null;
  compteurs: Compteur[];
  onEdit: () => void;
}

export default function CompteurHistory({
  open,
  onOpenChange,
  compteurType,
  compteurs,
  onEdit,
}: CompteurHistoryProps) {
  const numeroCompteur = compteurs.find((c) => c.numero_compteur)
    ?.numero_compteur;

  return (
    <ModalDialog
      open={open}
      size="xs"
      header={compteurType?.description}
      subtitle={numeroCompteur ? `N° ${numeroCompteur}` : undefined}
      onOpenChange={onOpenChange}
    >
      {compteurType && (
        <>
          <div className={styles.list}>
            <div className={styles.listHeader}>
              <Text as="span" variant="deci" weight="medium">
                Date
              </Text>
              <Text as="span" variant="deci" weight="medium">
                Index ({compteurType.unite})
              </Text>
            </div>

            {compteurs.length === 0 && (
              <Text className={styles.emptyState}>Aucun relevé</Text>
            )}

            {compteurs.map((compteur) => (
              <div key={compteur.id} className={styles.row}>
                <Text as="span">
                  {moment(compteur.date_releve).format("DD/MM/YYYY")}
                </Text>
                <Text as="span" weight="medium">
                  {compteur.valeur}
                  {compteurType.unite}
                </Text>
              </div>
            ))}
          </div>

          <ModalDialogFooter>
            <Button variant="secondary" icon={IconEdit} onClick={onEdit}>
              Modifier
            </Button>
          </ModalDialogFooter>
        </>
      )}
    </ModalDialog>
  );
}
